import React from 'react'
import CardSection from './CardSection'
import { CampaignCardState, useGetCampaignCardsByStateQuery } from '/~/types/graphql'
import { sortCampaignCards } from '/~/utils/arraySorting'
import { useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { getQueryDataFromURL } from '/~/utils/browserData'
import { normalizeNewApiCampaignCards, normalizeOldApiCampaignCards } from '/~/utils/campaignCard'
import { CardTypeEnum } from '/fiweb/components/CampaignCard/types'
import { useBreakpoint } from '/fiweb/lib'
import { client } from '/~/lib/issuer-client/client'
import { PublishedCampaignCardState, useGetPublishedCampaignCardsByStateQuery } from '/~/types/issuer-graphql'

interface Props {
  title?: string
}

const Ongoing = ({ title }: Props) => {
  const location = useLocation()
  const navigate = useNavigate()
  const { medium, large } = useBreakpoint()
  const { data, loading } = useGetCampaignCardsByStateQuery({
    variables: { state: [CampaignCardState.ONGOING] },
    pollInterval: 60000,
    notifyOnNetworkStatusChange: true,
  })

  const { data: newApiData, loading: newApiLoading } = useGetPublishedCampaignCardsByStateQuery({
    variables: { state: [PublishedCampaignCardState.ONGOING] },
    pollInterval: 60000,
    skip: !client,
    notifyOnNetworkStatusChange: true,
    client,
  })

  const cardList = React.useMemo(
    () => [
      ...normalizeOldApiCampaignCards(data?.campaignCardsByState || []),
      ...normalizeNewApiCampaignCards(newApiData?.publishedCampaignCardsByState || []),
    ],
    [data, newApiData],
  )

  const cards = React.useMemo(() => sortCampaignCards(cardList || [], CardTypeEnum.ONGOING), [cardList])
  const size = cards.length

  React.useEffect(() => {
    if (!(loading || newApiLoading)) {
      const queryStringData = getQueryDataFromURL(location.search)
      const slug = queryStringData['kommer-snart']

      if (slug) {
        const camp = cards.find((c) => c.slug === slug)
        if (camp) {
          if (camp.fromNewApi) {
            navigate(`/investeringstilbud/${slug}`)
          } else {
            navigate(`/kampanje/${slug}`)
          }
        }
      }
    }
  }, [loading, newApiLoading])

  if (!(loading || newApiLoading) && size === 0) {
    return null
  }

  return (
    <CardSection
      id='aapne-investeringsmulighter'
      title={title || 'Åpne investeringsmuligheter'}
      loading={loading || newApiLoading}
      name='ongoing'
      cards={cards}
      ignoreAdCard={!medium && cards.length % (large ? 2 : 3) === 0}
    />
  )
}

export default Ongoing
